import { Work } from '../types/interfaces'

export const works: Work[] = [
  {
    Name: 'Alfabit',
    Position: 'Especialista en Aplicaciones TI',
    HowLong: '12.2024 - presente',
    Tasks: [
      'Programación de servicios de red, aplicaciones y sitios web para clientes y empresas.',
      'Implementación de tecnologías inalámbricas y en la nube (automatización).',
      'Administración de servidores y gestión de API y bases de datos. Resolución de problemas y soporte técnico al cliente.',
    ],
  },
  {
    Name: 'Techgroup',
    Position: 'Técnico de telecomunicaciones',
    HowLong: '08.2025 - 09.2025',
    Tasks: [
      'Tendido e instalación de cables de fibra óptica. Servicio y mantenimiento de redes de telecomunicaciones.',
      'Configuración y mantenimiento de dispositivos de red y redes de internet domésticas.',
      'Programación de servicios y aplicaciones de red.',
    ],
  },
  {
    Name: 'Centro Nacional de Investigación Nuclear',
    Position: 'Pasante en el departamento de equipos nucleares',
    HowLong: '07.2025 - 08.2025',
    Tasks: [
      'Familiarización con la creación, verificación y validación de documentación tecnológica.',
      'Aprendizaje de los conceptos básicos de programación de controladores PLC Siemens y Beckhoff.',
      'Creación y prueba de software para el acelerador AQURE en lenguajes de programación C++ y C#.',
      'Montaje y puesta en marcha de componentes eléctricos de aceleradores. Realización de pruebas funcionales.',
    ],
  },
  {
    Name: 'Elepotrik',
    Position: 'Ingeniero en servicio electrónico',
    HowLong: '08.2024 - 09.2024',
    Tasks: [
      'Diagnóstico y reparación de dispositivos electrónicos, incluyendo equipos informáticos y móviles.',
      'Soldadura y sustitución de componentes electrónicos. Manejo de equipos de diagnóstico.',
      'Realización de pruebas funcionales y reparación de software en dispositivos.',
      'Toma de pedidos y contacto con el cliente.',
    ],
  },
  {
    Name: 'Lewe Korki',
    Position: 'Fundador del proyecto, tutor, desarrollador full-stack',
    HowLong: '07.2023 - 05.2024',
    Tasks: [
      'Creación y mantenimiento de una plataforma educativa para tutores y organización de clases a través de ella.',
      'Gestión de bases de datos: organización de usuarios y materiales didácticos.',
      'Tutoría de física y matemáticas para estudiantes de secundaria.',
    ],
  },
  {
    Name: 'Soulgraphy',
    Position: 'Creador y líder del proyecto, desarrollador front-end',
    HowLong: '11.2020 - 07.2021',
    Tasks: [
      'Creación y desarrollo de una plataforma de pruebas políticas, permitiendo el análisis de las opiniones de los usuarios.',
      'Gestión de un equipo de 20 personas, organización de debates juveniles y entrevistas con políticos.',
      'Logro de decenas de miles de visitas diarias.',
      'Presencia de la plataforma en línea: las pruebas aún están disponibles en <a href="https://soulgraphy.me">Soulgraphy</a>.',
    ],
  },
]
